import { object, string } from "yup";
import PageBlock from "@page-js/Pages/Page/Editor/scripts/pageBlock";

export default class Form extends PageBlock {
  public getType(): string {
    return "Form";
  }

  protected init(): any {
    return {
      props: {
        form: "",
      },
      attrs: {},
    };
  }

  public validateOrThrow(): Promise<any> {
    const schema = object().shape({
      props: object()
        .shape({
          form: string().uuid().required().label("폼 ID"),
        })
        .required()
        .label("옵션"),
      attrs: object().required().label("속성"),
    });

    return schema.validate(this.toJSON(), { abortEarly: false });
  }
}
